var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78305 7.72682L0.369862 13.1037C-0.0295375 13.5004 -0.0295375 14.1436 0.369862 14.5403C0.769262 14.9371 1.41682 14.9371 1.81622 14.5403L7.95258 8.44514C8.35198 8.04842 8.35198 7.40521 7.95258 7.00849L1.81622 0.91328C1.41682 0.516559 0.769262 0.516559 0.369862 0.91328C-0.0295375 1.31 -0.0295375 1.95321 0.369862 2.34994L5.78305 7.72682Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhite);
export default __webpack_public_path__ + "static/media/arrow_white.6bef4059f387603fdd6ea93865aab0c5.svg";
export { ForwardRef as ReactComponent };